import React from "react";
import { CircularProgress } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import styles from "./CranialSteps.module.css";

const STATUS_CLASS = {
  passed: styles.checkPassed,
  warning: styles.checkWarning,
  failed: styles.checkFailed,
};

const StatusIcon = ({ status }) => {
  if (status === "passed") return <CheckCircleOutlineIcon fontSize="small" />;
  if (status === "warning") return <WarningAmberOutlinedIcon fontSize="small" />;
  if (status === "failed") return <ErrorOutlineIcon fontSize="small" />;
  return <CircularProgress size={18} thickness={5} color="inherit" />;
};

/**
 * List of image checks with a status icon each.
 * @param {Array<{ key: string, label: string, status: 'passed'|'warning'|'failed'|null, message?: string }>} items
 */
function CheckStatusList({ items }) {
  return (
    <ul className={styles.checkList}>
      {items.map((item) => (
        <li key={item.key} className={styles.checkItem}>
          <span className={`${styles.checkIcon} ${STATUS_CLASS[item.status] || styles.checkPending}`}>
            <StatusIcon status={item.status} />
          </span>
          <div>
            <div className={styles.checkLabel}>{item.label}</div>
            {item.message && <div className={styles.checkMessage}>{item.message}</div>}
          </div>
        </li>
      ))}
    </ul>
  );
}

export default CheckStatusList;
